import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './claimed-matches.jade'
import {Match, User} from '../../models'
import notify from '@scoutgg/ftw/source/services/notification'
import '@scoutgg/ftw/source/atoms/toggle/toggle'

import '../status'
import '../results'
import '../golf-results'
import '../race-results'
import '../dota-results'
import '../duel-results'
import '../time-trial-results'
import '../individual-duel-results'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class ClaimedMatches extends HTMLElement {
  created() {
    this.popState = (ev) => {
      if(ev.state && ev.state.match) {
        this.match = ev.state.match
        this.render()
      }
    }
  }
  attached() {
    setTimeout(() => this.scrollWidth(), 1000)
    this.reload()
    this.on('reload:match', 'sporty-results', ({match}) => {
      if(!match) return
      var node = this.shadowRoot
      .querySelector(`sporty-status[match="${match._id}"]`)
      node && node.render()
    })
    if(this.match) this.match.load().then(() => this.render())
    window.addEventListener('popstate', this.popState)
  }

  detached() {
    window.removeEventListener('popstate', this.popState)
  }

  reload() {
    Match.load({$reload: true, user: User.current})
    .then(({matches}) => {
      this.realMatches = matches
      this.match || (this.match = matches[0])
      if(!this.match) return
      document.querySelector('sporty-match-controls').match = this.match._id
      this.render()
    })
  }

  claim(match, e) {
    e.stopPropagation()
    e.preventDefault()
    match = Match.instance(match)
    var prevUser = match.user
    var action
    if(prevUser === User.current) {
      action = 'unclaim'
      match.user = null
    } else {
      action = 'claim'
      match.user = User.current
    }
    match.post(action).then(() => {
      notify(`You've ${action}ed match ${match._id}`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
      match.user = prevUser
      this.render()
    })
    this.render(window.location.pathname = '/dashboard')
  }

  scrollWidth() {
    if(!this.clientWidth || !this.scroll) return
    this.scroll.style.maxHeight = `${this.clientWidth}px`
    this.scroll.style.height = `${this.clientWidth}px`
  }
  get scroll(){
    return this.shadowRoot.querySelector('.matches-list')
  }

  scrollMatches({name, className}) {
    let scroll = 250
    if(name === 'ui--right' || className === 'right') return (this.scroll.scrollTop += scroll)
    return (this.scroll.scrollTop -= scroll)
  }

  matchClass(match) {
    if(match.user && match.user === User.current) return 'owned'
    if(match.user) return 'claimed'
    var start = Date.parse(match.startTime)
    var isConfirmed = match.status === 'confirmed'
    if(!isConfirmed && !match.user && start < Date.now()) return 'urgent'
  }

  url(match) {
    let homeTeam = `${match?.homeTeam?.short + ' ' + (match?.score ? match?.score[0] : '')}`
    let awayTeam = `${(match?.score ? match?.score[1] : '') + ' ' + match?.awayTeam?.short}`
    if(['mma', 'tennis'].includes(match.sport)){
      let home = (match?.home).split(' '),
          away = (match?.away).split(' '),
      homeTeam = `${((home[1] || '').toUpperCase().slice(0,3) || '') + ' ' + (match?.score ? match?.score[0] : '')}`,
      awayTeam = `${(match?.score ? match?.score[1] : '') + ' ' + ((away[1] || '').toUpperCase().slice(0,3) || '')}`
      return ('/dashboard/' + match + `?home=${homeTeam}&away=${awayTeam}`)
    }

    if(!(['biathlon', 'cc_ski', 'golf', 'alpine'].includes(match.sport))) {
      return ('/dashboard/' + match + `?home=${homeTeam}&away=${awayTeam}`)
    }
    return ('/dashboard/' + match)
  }

  filterSport(sport) {
    return this.realMatches.filter(s => s.sport === sport)
  }
  get uniqueSports() {
    let matches = this.realMatches.map(match => match.sport)
    let sports = Array.from(new Set(matches))
    const order = {
      football: 1,
      hockey: 2,
      cricket: 3,
      basket: 4,
      cycling: 5,
      skiing: 6,
      tennis: 7,
      kabaddi: 8,
      alpine: 9,
    }
    if(this.match.sport && this.realMatches.length >= 6) {
      order[this.match.sport] = 1
      for(var key in order) {
        if(key !== this.match.sport) order[key] += 1
      }
    }
    return sports.sort((a, b) => order[a] - order[b])
  }
  get clientWidth() {
    return window.innerWidth
  }
}
